<template>
  <div class="shop">
    <div class="top">
      <el-button
        class="add-word"
        size="mini"
        type="primary"
        @click="showSearchModal"
        >添加商品</el-button
      >
    </div>

    <el-table
      :data="tableData"
      max-height="720"
      :cell-style="tc"
      :header-cell-style="tccolor"
    >
      <el-table-column label="活动" prop="id"></el-table-column>
      <el-table-column label="达标数量" prop="qualify_num"></el-table-column>
      <el-table-column label="奖励金额" prop="money"></el-table-column>
      <el-table-column label="已发奖励次数" prop="grant_num"></el-table-column>
      <el-table-column label="操作" fixed="right" width="200">
        <template slot-scope="scope">
          <el-button size="mini" @click="editPurchase(scope.row.id)"
            >编辑</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <el-col :span="24">
      <div class="pagination">
        <el-pagination
          background
          @current-change="pageChange"
          :current-page="form.page"
          :page-size="form.size"
          layout="total, prev, pager, next, jumper"
          :total="total"
        ></el-pagination>
      </div>
    </el-col>
    <!-- 关键词添加编辑 -->
    <jdialog
      title="添加/编辑活动商品"
      :visible.sync="showSwitch"
      width="1200px"
    >
      <div class="edit-box">
        <div class="left">
          <el-form
            :model="pushform"
            ref="ruleForm"
            label-width="120px"
            class="demo-ruleForm"
          >
            <el-form-item></el-form-item>
            <el-form-item label="活动图片:">
              <uploadImg
                flieName="goods_img"
                class="icon_cate"
                :oldImgs="[pushform.goods_img]"
                :n="1"
                @getFile="getFile"
              ></uploadImg>
            </el-form-item>
            <el-form-item label="活动名称:">
              <el-input
                v-model="pushform.goods_name"
                placeholder="输入数字不能有小数、不能负"
                size="mini"
                style="width: 220px"
              ></el-input>
            </el-form-item>
            <el-form-item label="达标数量:">
              <el-input
                v-model="pushform.qualify_num"
                placeholder="输入数字不能有小数、不能负"
                size="mini"
                style="width: 220px"
                :disabled="!this.addSwitch"
              ></el-input>
            </el-form-item>
            <el-form-item label="奖励设置:">
              <el-input
                v-model="pushform.money"
                placeholder="不能负数"
                size="mini"
                style="width: 220px"
                :disabled="!this.addSwitch"
              ></el-input>
            </el-form-item>
            <el-form-item label="单件批发编号:">
              <el-input
                v-model="pushform.goods_id"
                placeholder="商品编号"
                size="mini"
                style="width: 220px"
                :disabled="!this.addSwitch"
              ></el-input>
            </el-form-item>
            <el-form-item label="多件批发编号:">
              <el-input
                v-model="pushform.multiple_goods_id"
                placeholder="商品编号,商品编号,商品编号"
                size="mini"
                style="width: 220px"
                :disabled="!this.addSwitch"
              ></el-input>
            </el-form-item>
            <el-form-item label="状态:">
              <el-radio v-model="pushform.status" label="0">上架</el-radio>
              <el-radio v-model="pushform.status" label="1">下架</el-radio>
            </el-form-item>
            <el-form-item label="排序:">
              <el-input
                v-model="pushform.sort"
                size="mini"
                style="width: 220px"
              ></el-input>
            </el-form-item>
            <el-form-item style="text-align: center; margin-right: 120px">
              <el-button type="primary" size="mini" @click="addPurchase"
                >确定</el-button
              >
            </el-form-item>
          </el-form>
        </div>
        <div class="right">
          <h3>活动展示地区</h3>
          <aside class="items">
            <div
              class="icon-span"
              :class="countrySelect === true ? 'icon-span-select' : 'icon-span'"
              @click="handleCheckCountry()"
            >
              <i class="el-icon-check"></i>
            </div>
            <span>全国展示</span>
          </aside>
          <div
            class="items"
            v-for="(item, index) in this.regionGroups"
            :key="'g' + index"
          >
            <div class="mask" v-if="countrySelect === true"></div>
            <div style="display: flex; align-items: center">
              <!-- <div
                class="icon-span-gray"
                v-if="selectAreaArray[index] === true"
              >
                <i class="el-icon-check"></i>
              </div>

              <div
                class="icon-span"
                v-else
                :class="
                  checkAllGroup[index] === true
                    ? 'icon-span-select'
                    : 'icon-span'
                "
                @click="handleCheckAllChange(index)"
              >
                <i class="el-icon-check"></i>
              </div> -->

              <p
                style="
                  font-weight: 700;
                  float: left;
                  margin-right: 12px;
                  color: #999;
                "
                v-if="selectAreaArray[index] === true"
              >
                {{ item.name }}
              </p>
              <p
                v-else
                style="font-weight: 700; float: left; margin-right: 12px"
              >
                {{ item.name }}
              </p>

              <div v-for="(city, loc) in item.areas" :key="'s' + loc">
                <div
                  class="icon-span-gray"
                  v-if="selectCityIds[index][loc] !== 0"
                >
                  <i class="el-icon-check"></i>
                </div>

                <div
                  class="icon-span"
                  v-else
                  :class="
                    checkCityGroup[index][loc] === true
                      ? 'icon-span-select'
                      : 'icon-span'
                  "
                  @click="
                    handleCheckedCitiesChange(city.id, city.name, loc, index)
                  "
                >
                  <i class="el-icon-check"></i>
                </div>

                <p
                  style="float: left; margin-right: 12px; color: #999"
                  v-if="selectCityIds[index][loc] !== 0"
                >
                  {{ city.name }}
                </p>
                <p style="float: left; margin-right: 12px" v-else>
                  {{ city.name }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </jdialog>
  </div>
</template>

<script>
import uploadImg from '@/components/uploadImg'
import { setPurchase, editPurchase, getPurchase, getCitys } from '@/api/autarky'
export default {
  components: {
    uploadImg,
  },
  data() {
    return {
      tableData: [],
      showSwitch: false,
      form: {
        cate_id: '',
        cate_name: '',
        page: 1,
        size: 20,
        keyword_type: '',
      },
      total: 0,
      addSwitch: false,
      pushform: {
        goods_img: '',
        goods_name: '',
        goods_id: '',
        multiple_goods_id: '',
        qualify_num: '',
        money: '',
        status: '0',
        sort: '',
        id: '',
      },
      countrySelect: false,
      regionGroups: [],
      checkAllGroup: [],
      checkedCities: [],
      checkCityGroup: [],
      selectCityIds: [],
      selectAreaArray: [],
    }
  },
  mounted() {
    this.getListData()
    this.getCitysData()
  },
  methods: {
    //获取列表数据
    async getListData() {
      var url =
        'page=' + this.form.page + '&keyword_type=' + this.form.keyword_type
      let res = await setPurchase(url)
      if (res.code === 10000) {
        this.tableData = res.data
      } else {
        this.$message.error(res.message)
      }
    },
    async getCitysData() {
      let res = await getCitys()
      if (res.code === 10000) {
        const arr = [...res.data]
        this.regionGroups = arr
        res.data.map((item) => {
          console.log(item)

          this.checkAllGroup.push(false)
          this.selectAreaArray.push(false)
          var arr1 = []
          var checkcArr = []
          var idarr = []
          item.areas.map((city) => {
            console.log(city)
            arr1.push(false)
            checkcArr.push({})
            idarr.push(0)
          })
          this.checkCityGroup.push(arr1)
          this.checkedCities.push(checkcArr)
          this.selectCityIds.push(idarr)
        })
      } else {
        this.$message.error(res.message)
      }
    },
    handleCheckCountry() {
      console.log(this.checkedCities)
      if (!this.countrySelect) {
        this.countrySelect = true
        var citySelArr = []
        var cityarr = []
        // var cityIdarr = []
        for (let index = 0; index < this.regionGroups.length; index++) {
          // this.checkAllGroup[index] === true
          this.regionGroups[index].areas.map((sel) => {
            citySelArr.push(sel)
            cityarr.push(true)
            // cityIdarr.push(sel.id)
          })
          this.checkedCities[index] = citySelArr
          this.checkCityGroup[index] = cityarr
        }
      } else {
        this.countrySelect = false
        for (let i = 0; i < this.regionGroups.length; i++) {
          // this.checkAllGroup[i] === false
          var citySelArr1 = []
          var cityarr1 = []
          // var cityIdarr1 = []
          this.regionGroups[i].areas.map((sel) => {
            console.log(sel)
            cityarr1.push(false)
            //  cityIdarr1.push(0)
            citySelArr1.push({})
          })
          this.checkedCities[i] = citySelArr1
          this.checkCityGroup[i] = cityarr1
        }
      }
      this.$forceUpdate()
    },
    handleCheckAllChange(index) {
      if (this.checkAllGroup[index] === false) {
        this.checkAllGroup[index] = true
        var citySelArr = []
        var cityarr = []
        // var cityIdarr = []

        this.regionGroups[index].areas.map((sel) => {
          citySelArr.push(sel)
          cityarr.push(true)
          // cityIdarr.push(sel.id)
        })
        this.checkedCities[index] = citySelArr
        this.checkCityGroup[index] = cityarr
        // this.selectCityIds[index]   = cityIdarr
        console.log(this.checkedCities)
        console.log(this.checkCityGroup)
        // console.log(this.selectCityIds)
      } else {
        this.checkAllGroup[index] = false
        this.checkCityGroup[index].map((item) => {
          console.log(item)
        })

        var citySelArr1 = []
        var cityarr1 = []
        // var cityIdarr1 = []
        this.regionGroups[index].areas.map((sel) => {
          console.log(sel)
          cityarr1.push(false)
          //  cityIdarr1.push(0)
          citySelArr1.push({})
        })
        this.checkedCities[index] = citySelArr1
        this.checkCityGroup[index] = cityarr1
        // this.selectCityIds[index] = cityIdarr1
        console.log(this.checkedCities)
        console.log(this.checkCityGroup)
        // console.log(this.selectCityIds)
      }
      this.$forceUpdate()
    },
    handleCheckedCitiesChange(id, name, loc, index) {
      if (this.checkCityGroup[index][loc] === false) {
        this.checkCityGroup[index][loc] = true
        this.checkedCities[index][loc] = this.regionGroups[index].areas[loc]
      } else {
        this.checkCityGroup[index][loc] = false
        this.checkedCities[index][loc] = {}
      }

      this.$forceUpdate()
    },
    //新增模版
    getfreightTemplateAdd() {
      this.countrySelect = false
      this.selectAreaArray = []
      this.selectCityIds = []
      this.checkAllGroup = []
      this.checkCityGroup = []
      this.checkedCities = []
      this.regionGroups.map((item) => {
        this.checkAllGroup.push(false)
        this.selectAreaArray.push(false)
        var arr = []
        var checkcArr = []
        var idarr = []
        item.areas.map((city) => {
          console.log(city);
          arr.push(false)
          checkcArr.push({})
          idarr.push(0)
        })
        this.checkCityGroup.push(arr)
        this.checkedCities.push(checkcArr)
        this.selectCityIds.push(idarr)
      })
      console.log(this.checkCityGroup)
    },

    //编辑模版
    getfreightTemplateEditData() {
      this.selectAreaArray = []
      this.selectCityIds = []
      this.regionGroups.map((item) => {
        this.checkAllGroup.push(false)
        this.selectAreaArray.push(false)
        var arr = []
        var checkcArr = []
        var idarr = []
        item.areas.map((city) => {
          console.log(city)
          arr.push(false)
          checkcArr.push({})
          idarr.push(0)
        })
        this.checkCityGroup.push(arr)
        this.checkedCities.push(checkcArr)
        this.selectCityIds.push(idarr)
        console.log(this.regionGroups)
      })
      this.$forceUpdate()
    },
    //新增&&编辑关键词
    showSearchModal() {
      this.getfreightTemplateAdd()
      this.pushform = {
        goods_img: '',
        goods_name: '',
        goods_id: '',
        multiple_goods_id: '',
        qualify_num: '',
        money: '',
        status: '0',
        sort: '',
        id: '',
      }
      this.addSwitch = true
      this.showSwitch = true
    },

    editPurchase(id) {
      this.getPurchaseMsg(id)
    },

    async getPurchaseMsg(id) {
      
      let res = await getPurchase({ id })
      if (res.code === 10000) {
        // this.getfreightTemplateAdd()
        this.addSwitch = false
        this.showSwitch = true
        this.pushform = {
          goods_img: res.data.goods_img,
          goods_name: res.data.goods_name,
          goods_id: res.data.goods_id,
          multiple_goods_id: res.data.multiple_goods_id,
          qualify_num: res.data.qualify_num,
          money: res.data.money,
          status: res.data.status.toString(),
          sort: res.data.sort,
          id,
        }
        if (res.data.region_all == 1) {
          this.countrySelect = true
          return false
        } else {
          this.countrySelect = false
        }
        // this.checkCityGroup = []
        // this.checkedCities = []
        // this.regionGroups.map((item) => {
        //   var arr = []
        //   var checkcArr = []
        //   item.areas.map((city) => {
        //     arr.push(false)
        //     checkcArr.push({})
        //   })
        //   this.checkCityGroup.push(arr)
        //   this.checkedCities.push(checkcArr)
        // })
        this.getfreightTemplateAdd()
        let newCheckedCities = [...this.checkedCities]
        let newCheckCityGroup = [...this.checkCityGroup]
        for (let index = 0; index < this.regionGroups.length; index++) {
          this.regionGroups[index].areas.map((sel, a) => {
            res.data.region_id.map((regionItem) => {
              if (regionItem == sel.areaCode) {
                newCheckedCities[index][a] = sel
                newCheckCityGroup[index][a] = true
              }
            })
          })
        }
        this.checkedCities = newCheckedCities
        this.checkAllGroup = newCheckCityGroup
      } else {
        this.$message.error(res.message)
      }
    },

    async addPurchase() {
      let cityData = {}
      const region_all = this.countrySelect ? 1 : 0
      let idArr = []
      this.checkedCities.map((item) => {
        item.map((cc) => {
          if (cc && cc.areaCode && cc.name) {
            idArr.push(cc.areaCode)
          }
        })
      })
      if (this.countrySelect) {
        cityData = {
          region_all,
          region_id: [],
        }
      } else {
        cityData = {
          region_all,
          region_id: idArr,
        }
      }

      let pushform = this.pushform
      const newForm = Object.assign(pushform, cityData)
      console.log(newForm)
      let res = await editPurchase(newForm)
      if (res.code === 10000) {
        this.getListData()
        this.showSwitch = false
      } else {
        this.$message.error(res.message)
      }
    },

    // // 隐藏显示
    // async switchSearchword(showtype, id) {
    //   let data = {
    //     is_delete: showtype == 1 ? 2 : 1,
    //     id: id,
    //   }
    //   let res = await switchSearchword(data)
    //   if (res.code === 10000) {
    //     this.getListData()
    //   } else {
    //     this.$message.error(res.message)
    //   }
    // },

    // 分页设置
    pageChange(page) {
      this.form.page = page
      //获取更多数据
      this.getListData()
    },
    tc() {
      return 'text-align:center; color:#333333; font-size:12px;'
    },
    tccolor() {
      return 'text-align:center;background-color:#f5f5f5; font-size:14px;'
    },
    getFile(file) {
      console.log(file)
      this.pushform[file.name] = file.files.length > 0 ? file.files[0].url : ''
    },
  },
}
</script>
<style lang="scss" scoped>
.shop {
  padding: 20px;
  .add-word {
    float: right;
    margin-bottom: 10px;
  }
  .pagination {
    float: right;
    margin-top: 12px;
  }
  .search {
    margin-right: 10px;
  }
}
.edit-box {
  display: flex;
  .left {
    margin-right: 100px;
  }
  .right {
    box-sizing: border-box;
    padding-top: 100px;
    h3 {
      margin-bottom: 20px;
    }
    aside {
      span {
        font-weight: 700;
      }
    }
    .items {
      margin-bottom: 20px;
      position: relative;
      .mask {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        background: rgba(255, 255, 255, 0.7);
      }
    }
  }
  .icon-span {
    width: 20px;
    height: 20px;
    border: 1px solid #d8d8d8;
    background-color: #fff;
    text-align: center;
    margin-right: 8px;
    float: left;
    line-height: 20px;
    i {
      color: #fff;
    }
  }
  .icon-span-gray {
    width: 20px;
    height: 20px;
    border: 1px solid #d8d8d8;
    background-color: #f8f8f8;
    text-align: center;
    margin-right: 8px;
    float: left;
    line-height: 20px;
    i {
      color: #666;
    }
  }
  .icon-span-select {
    background-color: #f4222d;
    i {
      color: #fff;
    }
  }
}
</style>
